import { Contact } from '../models/contact.model';
import { Customer } from '../models/customer.model';

/**
 * Converts a Contact object (from backoffice CRM) to a Customer
 * in the format expected by Sale, Invoice, and Quote APIs.
 */
export function contactToCustomer(contact: Contact): Customer {
  const data = contact.data ?? (contact as any)
  return {
    type: contact.type as 'person' | 'company',
    is_user: false,
    data: {
      id: contact.id ?? data.id ?? '',
      contact_code: data.contact_code ?? '',
      uuid: data.uuid ?? '',
      name: data.name ?? '',
      first_name: data.first_name ?? '',
      last_name: data.last_name ?? '',
      avatar: data.avatar ?? '',
      logo: data.logo ?? '',
      email: data.email ?? '',
      phone: data.phone ?? '',
      website: data.website ?? '',
      register_number: data.register_number ?? '',
      vat_number: data.vat_number ?? '',
      currency: data.currency ?? null,
      address: data.address ?? null,
      bank_account: data.bank_account ?? null,
    },
  }
}
